import { useEffect } from 'react'
import {
  featureFlags,
  isEnabledForClientReview,
  isFeatureEnabled,
} from '@featureflags'
import { readConsentCookie } from '@utils'

// only works in production
const useGtag = ({
  action,
  categories = [],
  label,
  eventCallback = () => {},
  skipEventEmission = false,
}) => {
  useEffect(() => {
    if (!isFeatureEnabled(featureFlags.GTAG)) return
    if (!window?.gtag) return
    if (!action || !label || skipEventEmission) return
    // Read at emission time rather than from a snapshot, so a consent change
    // part-way through the session takes effect immediately. Consent Mode also
    // gates these tags at Google's end; this is a belt-and-braces check.
    if (!readConsentCookie()?.analytics) return

    const logEventEmission = (trackingId, category) => {
      if (isEnabledForClientReview) {
        console.info('GTAG Event emitted:', {
          trackingId,
          action,
          category,
          label,
        })
      }
    }

    categories.forEach(category => {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        event_callback: trackingId => {
          // Note that the event is emitted for both `GOOGLE_ANALYTICS_ID` and `GOOGLE_TAGMANAGER_ID`
          // but the `GOOGLE_TAGMANAGER_ID` event is currently not being processed by GTM
          logEventEmission(trackingId, category)
          eventCallback(trackingId)
        },
      })
    })
  }, [action, categories, label, eventCallback, skipEventEmission])
}

export default useGtag
export { useGtag }
